module.exports = __webpack_public_path__ + "static/competition-a74757d9a66dcfe18b2adfa10ed0eeac.svg";